<ng-container>
  <iframe style="height: 100%; width: 100%;" #iframe (load)="onLoad(iframe)" [attr.srcDoc]="initialContent"></iframe>
</ng-container>
